import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { QUERIES } from "../../../config/apiConfig";
import axios from "../../../config/axiosInstance";
import DrawerLoading from "../../DrawerLoading";
import RelatorioEssencialPJQuery from "../../queries/RelatorioEssencialPJQuery";
import RelatorioEssencialPFQuery from "../../queries/RelatorioEssencialPFQuery";
import RelatorioAvancadoPJQuery from "../../queries/RelatorioAvancadoPJQuery";
import RelatorioAvancadoPFQuery from "../../queries/RelatorioAvancadoPFQuery";

const queries = [
  {
    id: 1,
    name: "Relatório Essencial PJ",
    component: <RelatorioEssencialPJQuery />,
  },
  {
    id: 2,
    name: "Relatório Essencial PF",
    component: <RelatorioEssencialPFQuery />,
  },
  {
    id: 3,
    name: "Relatório Avancado PJ",
    component: <RelatorioAvancadoPJQuery />,
  },
  {
    id: 4,
    name: "Relatório Avançado PF",
    component: <RelatorioAvancadoPFQuery />,
  },
];

const SelectedQueryReview = ({ query }) => {
  const {
    isLoading,
    error,
    data: queryData,
  } = useQuery(
    ["queryData", query],
    async () => {
      const { data } = await axios.get(
        `${QUERIES.GET_USER_QUERY}/${query?.id}`
      );

      return data.data;
    },
    {
      enabled: !!query,
    }
  );

  const getComponentByQueryId = (queryId) => {
    const queryMatch = queries.find((q) => q.id === queryId);
    if (!queryMatch) return <div>Consulta não reconhecida</div>;

    return React.cloneElement(queryMatch.component, {
      dataFromLocalStorage: queryData?.data, // se o componente usar
    });
  };

  return (
    <div className="relative">
      {queryData && (
        <>{queryData && getComponentByQueryId(queryData?.QueryId)}</>
      )}
      {isLoading && <DrawerLoading />}
    </div>
  );
};

export default SelectedQueryReview;
